import React, { useState, useEffect } from 'react';
import './HeaderSlider.css';

const HeaderSlider = () => {
    const slides = [
        {
            image: "/Images/header-slider/slide1.png",
            title: "Sustainable Engineering Solutions"
        },
        {
            image: "/Images/header-slider/slide2.png",
            title: "Trusted Partner in Engineering"
        },
        {
            image: "/Images/header-slider/slide3.png",
            title: "Built to Perform with Innovation & Integrity"
        }
    ];

    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) =>
                prevIndex === slides.length - 1 ? 0 : prevIndex + 1
            );
        }, 5000);

        return () => clearInterval(interval);
    }, [slides.length]);

    return (
        <div className="header">
            <div className="header__text-overlay">
                <h1 key={currentIndex} className="header__text">
                    {slides[currentIndex].title}
                </h1>
            </div>
            <div
                className="header__s1"
                style={{ transform: `translateX(-${currentIndex * 100}%)` }}
            >
                {slides.map((slide, index) => (
                    <img
                        key={index}
                        src={slide.image}
                        alt={`Slide ${index}`}
                        className="header__image"
                    />
                ))}
            </div>
        </div>
    );
};

export default HeaderSlider;